<template>
  <div>
    <md-field :class="getValidationClass('profundidadeTubo')">
      <label for="profundidadeTubo">Profundidade do Tubo (m)</label>
      <md-input
        v-model.number="rede.profundidadeTubo"
        type="number"
        @change="handleChange"
      />
      <span v-if="!$v.rede.profundidadeTubo.required" class="md-error"
        >Profundidade do Tubo é obrigatório</span
      >
    </md-field>

    <md-field :class="getValidationClass('diametroTubo')">
      <label for="diametroTubo">Diâmetro do Tubo (mm)</label>
      <md-input
        v-model.number="rede.diametroTubo"
        type="number"
        @change="handleChange"
      />
      <span v-if="!$v.rede.diametroTubo.required" class="md-error"
        >Diâmetro do Tubo é obrigatório</span
      >
    </md-field>

    <md-field :class="getValidationClass('distanciaHorizontalTuboAoMeioFio')">
      <label for="distanciaHorizontalTuboAoMeioFio"
        >Distância Horizontal do Tubo ao Meio Fio (m)</label
      >
      <md-input
        v-model.number="rede.distanciaHorizontalTuboAoMeioFio"
        type="number"
        @change="handleChange"
      />
      <span
        v-if="!$v.rede.distanciaHorizontalTuboAoMeioFio.required"
        class="md-error"
        >Distância Horizontal é obrigatório</span
      >
    </md-field>

    <md-field>
      <label for="materialTubo">Material Tubo</label>
      <md-select
        id="materialTubo"
        v-model="rede.materialTubo"
        name="materialTubo"
        @md-selected="handleChange"
      >
        <md-option value="PVC Azul"> PVC Azul </md-option>
        <md-option value="PVC Marrom"> PVC Marrom </md-option>
        <md-option value="Ferro Fundido"> Ferro Fundido </md-option>
        <md-option value="Cimento Amianto"> Cimento Amianto </md-option>
        <md-option value="Outro"> Outro </md-option>
      </md-select>
    </md-field>

    <md-field v-if="rede.materialTubo === 'Outro'">
      <label for="materialTubo">Especificar o material</label>
      <md-input v-model.trim="rede.materialTuboOutro" @change="handleChange" />
    </md-field>

    <md-field>
      <label for="localInstalacao">Local de Instalação do tubo</label>
      <md-select
        id="localInstalacao"
        v-model="rede.localInstalacao"
        name="localInstalacao"
        @md-selected="handleChange"
      >
        <md-option value="Pista Asfalto"> Pista com Asfalto </md-option>
        <md-option value="Pista Terra"> Pista de Terra </md-option>
        <md-option value="Calcada"> Calçada </md-option>
        <md-option value="Outro"> Outro </md-option>
      </md-select>
    </md-field>

    <md-field v-if="rede.localInstalacao === 'Outro'">
      <label for="materialTubo">Especificar o local de instalação</label>
      <md-input
        v-model.trim="rede.localInstalacaoOutro"
        @change="handleChange"
      />
    </md-field>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'FormularioRedeSig',
  mixins: [validationMixin],
  props: {
    data: Object,
  },
  data() {
    return {
      rede: {
        profundidadeTubo: null,
        diametroTubo: null,
        distanciaHorizontalTuboAoMeioFio: null,
        materialTubo: null,
        materialTuboOutro: null,
        localInstalacao: null,
        localInstalacaoOutro: null,
      },
    }
  },
  validations: {
    rede: {
      profundidadeTubo: { required },
      diametroTubo: { required },
      distanciaHorizontalTuboAoMeioFio: { required },
      materialTubo: { required },
      materialTuboOutro: {},
      localInstalacao: { required },
      localInstalacaoOutro: {},
    },
  },
  beforeMount() {
    if (this.data) {
      this.rede = { ...this.data }
    }
  },
  methods: {
    getValidationClass(fieldName) {
      const field = this.$v.rede[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty,
        }
      }
    },
    handleChange() {
      this.$v.$touch()

      this.$forceUpdate()

      this.$emit('change', {
        isValid: !this.$v.$invalid,
        data: { ...this.rede },
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>
